import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Table,
  message,
  Form,
  Modal,
  Select,
  Spin,
  Space,
  Row,
  Col,
  Tooltip,
  Card,
  Typography,
  Input,
} from "antd";
import {
  CarOutlined,
  CheckCircleOutlined,
  ShareAltOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ReloadOutlined,
  SearchOutlined,
  UnlockOutlined,
  LockOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { AiFillAlert, AiFillDelete, AiFillEdit } from "react-icons/ai";
import {
  IoPersonSharp,
  IoReload,
  IoCheckmarkCircleSharp,
  IoLockClosedSharp,
  IoLockOpen,
} from "react-icons/io5";
import { MdAddHome } from "react-icons/md";
import Search from "antd/es/input/Search";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { getRouteData } from "../servicios/osrmService";

const { Title } = Typography;

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_APPI_ADDRESS,
});
const { Option } = Select;

const DeliveryAssignment = () => {
  if (sessionStorage.getItem("user_mod")) sessionStorage.removeItem("user_mod");

  const { t, i18n } = useTranslation();
  const [bottom, setBottom] = useState("bottomCenter");
  const [original, setOriginal] = useState([]);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [spinning, setSpinning] = useState(false);
  const [spinTitle, setSpinTitle] = useState(t("global.loading"));
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading] = useState(false);
  const [searchValue, setSearchValue] = useState(""); // Estado para controlar el valor del input
  const [completarCargaButtonDisabled, setCompletarCargaButtonDisabled] =
    useState(true);
  const [habilitarCargaButtonDisabled, setHabilitarCargaButtonDisabled] =
    useState(true);
  const [editarCargaButtonDisabled, setEditarCargaButtonDisabled] =
    useState(true);

  const headers = {
    accept: "*/*",
    Authorization: "Bearer " + sessionStorage.getItem("token"),
    "Content-Type": "application/json",
  };

  useEffect(() => {
    recargar();
  }, []);

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));

  const columns = [
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_matricula")}
        </p>
      ),
      dataIndex: "matricula",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.matricula),
        _.isEqual
      ),
      onFilter: (value, record) => record.matricula.startsWith(value),
      sorter: (a, b) => a.matricula.localeCompare(b.matricula),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_tipo_vehiculo")}
        </p>
      ),
      dataIndex: "tipo_vehiculo",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.tipo_vehiculo),
        _.isEqual
      ),
      onFilter: (value, record) => record.tipo_vehiculo.startsWith(value),
      sorter: (a, b) => a.tipo_vehiculo.localeCompare(b.tipo_vehiculo),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_capacidad_carga")}
        </p>
      ),
      dataIndex: "capacidad_carga",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.capacidad_carga),
        _.isEqual
      ),
      onFilter: (value, record) => record.capacidad_carga.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_capacidad_carga_ocupada")}
        </p>
      ),
      dataIndex: "capacidad_ocupada",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.capacidad_ocupada),
        _.isEqual
      ),
      onFilter: (value, record) => record.capacidad_ocupada.startsWith(value),
      render: (text, record) => {
        const isFullCapacity =
          record.capacidad_ocupada > record.capacidad_carga;
        return (
          <span style={{ color: isFullCapacity ? "red" : "inherit" }}>
            {text}
          </span>
        );
      },
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_capacidad_carga_libre")}
        </p>
      ),
      dataIndex: "capacidad_libre",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.capacidad_libre),
        _.isEqual
      ),
      onFilter: (value, record) => record.capacidad_libre.startsWith(value),
      render: (text) => {
        const isPositive = Number(text) > 0;
        return (
          <span style={{ color: isPositive ? "green" : "red" }}>{text}</span>
        );
      },
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_chofer")}
        </p>
      ),
      dataIndex: "fullname",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.fullname),
        _.isEqual
      ),
      onFilter: (value, record) => record.fullname.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_full_charge")}
        </p>
      ),
      dataIndex: "completado",
      // width: 200,
      render: (text) =>
        text === "1" ? (
          <IoCheckmarkCircleSharp size={20} color={"green"} />
        ) : (
          <IoCheckmarkCircleSharp size={20} color={"#adb5bd"} />
        ),
      // filterSearch: true,
      // filters: _.uniqWith(filterData(data)(i => i.activo), _.isEqual),
      // onFilter: (value, record) => record.activo.startsWith( value ),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_route")}
        </p>
      ),
      dataIndex: "rutagenerada",
      // width: 200,
      render: (text) =>
        text === "1" ? (
          <IoCheckmarkCircleSharp size={20} color={"green"} />
        ) : (
          <IoCheckmarkCircleSharp size={20} color={"#adb5bd"} />
        ),
      // filterSearch: true,
      // filters: _.uniqWith(filterData(data)(i => i.activo), _.isEqual),
      // onFilter: (value, record) => record.activo.startsWith( value ),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("assignment.col_confirmada")}
        </p>
      ),
      dataIndex: "confirmada",
      // width: 200,
      render: (text) =>
        text === "1" ? (
          <IoCheckmarkCircleSharp size={20} color={"green"} />
        ) : (
          <IoCheckmarkCircleSharp size={20} color={"#adb5bd"} />
        ),
      // filterSearch: true,
      // filters: _.uniqWith(filterData(data)(i => i.activo), _.isEqual),
      // onFilter: (value, record) => record.activo.startsWith( value ),
    },
  ];

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: data.length, // Asegúrate de tener el total de elementos aquí
  });

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  const recargar = () => {
    //limpiar la busqueda del componente Search
    setSearchValue("");

    setSpinTitle(t("global.loading"));
    setSpinning(true);
    setSelectedRowKeys([]);
    let aux = [];

    let start = 0;
    let limit = 1000;

    Axios.post(
      "sd/getVehiculosCargados",
      {
        // "start": start,
        // "limit": limit,
        // "filtro":{
        //     "idrol": 1
        // }
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            aux.push({
              key: response.data.data[i].idvehiculo,
              idasignacion: response.data.data[i].idasignacion,
              idvehiculo: response.data.data[i].idvehiculo,
              matricula: response.data.data[i].matricula,
              capacidad_carga: response.data.data[i].capacidad_carga,
              capacidad_ocupada: response.data.data[i].capacidad_ocupada,
              capacidad_libre: response.data.data[i].capacidad_libre,
              fullname: response.data.data[i].fullname,
              tipo_vehiculo: response.data.data[i].tipo_vehiculo,
              completado: response.data.data[i].completado,
              rutagenerada: response.data.data[i].rutagenerada,
              confirmada: response.data.data[i].confirmada,
            });
          }
        }

        setData(aux);
        setOriginal(aux);
      })
      .catch((error) => {
        setSpinning(false);
      });
  };

  const getInfoForm = async (id) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].idvehiculo === id) {
        return data[i];
      }
    }
    return [];
  };

  const modificar = async () => {
    form.resetFields();
    const row = await getInfoForm(selectedRowKeys[0]);
    // console.log(row);
    sessionStorage.setItem("sessionStorage", JSON.stringify(row));
  };

  const eliminar = (e) => {
    Modal.confirm({
      title: "Eliminar asignación",
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <span>{t("assignment.delete_confirm")}</span>
        </div>
      ),
      onOk() {
        setSpinTitle(t("global.processing_data"));
        setSpinning(true);
        Axios.delete("sd/deleteAsignacion", {
          data: {
            idvehiculo: selectedRowKeys,
          },
          headers: headers,
        })
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              messageApi.open({
                type: "success",
                content: response.data.message || t("assignment.delete_success"),
                duration: 2.5,
              });
              recargar();
            } else {
              const errorMessage = response.data.message || response.data.error || t("assignment.delete_error");
              messageApi.open({
                type: "error",
                content: errorMessage,
                duration: 3,
              });
            }
          })
          .catch((error) => {
            setSpinning(false);
            let errorMessage = t("assignment.delete_error");
            if (error.response?.data) {
              errorMessage = error.response.data.message || error.response.data.error || errorMessage;
            }
            messageApi.open({
              type: "error",
              content: errorMessage,
              duration: 3,
            });
          });
      },
    });
  };

  const onSearch = (value, _e, info) => {
    filterLocal(value);
  };

  const filterLocal = (value) => {
    if (value === "" || value === null) {
      setData(original);
    } else {
      let aux = [];
      original.forEach(function (option) {
        if (
          option.matricula.toUpperCase().indexOf(value.toUpperCase()) !== -1
        ) {
          aux.push(option);
        }
      });
      setData(aux);
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length === 1) {
      const selectedRow = data.find((row) => row.key === newSelectedRowKeys[0]);
      if (selectedRow) {
        setCompletarCargaButtonDisabled(selectedRow.completado == 1);
        setHabilitarCargaButtonDisabled(selectedRow.completado == 0);
        setEditarCargaButtonDisabled(selectedRow.completado == 1);
      }
    } else {
      setCompletarCargaButtonDisabled(true);
      setHabilitarCargaButtonDisabled(true);
      setEditarCargaButtonDisabled(true);
    }
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const selectRowUpdate = async (record) => {
    setSelectedRowKeys([record.key]);
    form.resetFields();
    let row = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].idvehiculo === record.key) {
        row = data[i];
      }
    }

    sessionStorage.setItem("user_mod", JSON.stringify(row));
    navigate(`/editTipoVehiculo/${record.key}`);
  };

  function activacion(e, activar) {
    Modal.confirm({
      title: activar ? "Completar carga" : "Habilitar carga",
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <span>
            ¿Desea {activar ? "completar" : "habilitar"} la carga del vehículo
            seleccionado?
          </span>
        </div>
      ),
      onOk() {
        setSpinTitle(
          activar
            ? "Finlizando carga del vehículo..."
            : "Habilitando carga del vehículo..."
        );
        setSpinning(true);
        Axios.post(
          "sd/completarCargaVehiculo",
          {
            idvehiculo: selectedRowKeys,
            completado: activar ? 1 : 0,
          },
          {
            headers: headers,
          }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              messageApi.open({
                type: "success",
                content: "Los datos han sido procesados con éxito.",
                duration: 0,
              });
              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: "Error procesando los datos.",
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: "Error procesando los datos.",
              duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  }

  function generarRuta() {
    Modal.confirm({
      title: "Generar ruta",
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <span>¿Desea generar la ruta para el vehículo seleccionado?</span>
        </div>
      ),
      onOk() {
        setSpinTitle("Generando la ruta...");
        setSpinning(true);
        Axios.post(
          "sd/generarRuta",
          {
            idvehiculo: selectedRowKeys,
          },
          {
            headers: headers,
          }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              // console.log(response.data.data[0]);

              let coordinatesArray = JSON.parse(response.data.data[0].ruta);
              //console.log(coordinatesArray);

              // Validar que no haya subarrays con valores null
              if (
                coordinatesArray.some((coordinate) => coordinate.includes(null))
              ) {
                messageApi.open({
                  type: "error",
                  content:
                    "El array de coordenadas contiene valores nulos. No se puede continuar con la generación de la ruta.",
                  duration: 0,
                });
                setTimeout(messageApi.destroy, 2500);
                return; // Detener ejecución si hay valores null
              }

              getRouteData(coordinatesArray)
                .then(({ distance, duration, geometry }) => {
                  // console.log(`Distancia: ${(distance / 1000).toFixed(2)} km`);
                  // console.log(
                  //   `Duración: ${(duration / 3600).toFixed(2)} horas`
                  // );
                  // console.log("Ruta GeoJSON:", geometry);

                  //sumarle 15min por cada punto de entrega, es lo que debe demorar el repartidor en entregar el paquete.
                  const tiempoEntrega = (coordinatesArray.length - 1) * 15 * 60;
                  duration = duration + tiempoEntrega;

                  const hours = Math.floor(duration / 3600); // Horas completas
                  const minutes = Math.floor((duration % 3600) / 60); // Minutos restantes

                  const tiempoEstimado =
                    hours > 0
                      ? `${hours} horas${
                          minutes > 0 ? ` y ${minutes} minutos` : ""
                        }`
                      : `${minutes} minutos`;

                  Axios.post(
                    "sd/updateValoresRuta",
                    {
                      idruta: response.data.data[0].idruta,
                      distanciatotal: `${(distance / 1000).toFixed(2)} km`,
                      // tiempoestimado: `${(duration / 3600).toFixed(2)} horas`,
                      tiempoestimado: tiempoEstimado,
                    },
                    {
                      headers: headers,
                    }
                  );
                })
                .catch((error) => console.error("Error:", error));

              messageApi.open({
                type: "success",
                content: "Los datos han sido procesados con éxito.",
                duration: 0,
              });
              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: "Error procesando los datos.",
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: "Error procesando los datos.",
              duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  }

  function confirmar(e, activar) {
    Modal.confirm({
      title: activar ? "Confirmar ruta" : "Desconfirmar ruta",
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <span>
            ¿Desea {activar ? "confirmar" : "desconfirmar"} la ruta de este
            vehículo?
          </span>
        </div>
      ),
      onOk() {
        setSpinTitle(t("global.processing_data"));
        setSpinning(true);
        let message = "";
        Axios.post(
          "sd/confirmarRuta",
          {
            idvehiculo: selectedRowKeys[0],
            confirmada: activar ? 1 : 0,
          },
          {
            headers: headers,
          }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              message = response.data.message;
              messageApi.open({
                type: "success",
                content: message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: message,
              duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: "16px"
    }}>
      <Spin spinning={spinning} tip={spinTitle} size={"large"}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
          borderRadius: '8px',
          padding: '12px',
          marginBottom: '12px',
          color: 'white'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px'
            }}>
              <ShareAltOutlined />
            </div>
            <div style={{ flex: 1 }}>
              <Title level={4} style={{
                color: 'white',
                margin: 0,
                fontSize: '16px'
              }}>
                {t("assignment.title")}
              </Title>
              <p style={{
                color: 'rgba(255,255,255,0.8)',
                margin: 0,
                fontSize: '12px'
              }}>
                Asignación de cargas • {data.length} vehículos
              </p>
            </div>
            <div style={{
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '8px',
              padding: '8px 16px'
            }}>
              <p style={{ color: 'white', margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                {data.length} vehículos
              </p>
            </div>
          </div>
        </div>
        {contextHolder}
        {/* Toolbar */}
        <Card style={{
          marginBottom: '12px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: 'none'
        }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            alignItems: 'center'
          }}>
            <Link to="/vehicleassignment">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                disabled={loading}
                size="small"
                style={{
                  background: loading
                    ? '#d9d9d9'
                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                  borderColor: loading ? '#d9d9d9' : '#253289',
                  borderRadius: '8px',
                  height: '32px',
                  fontWeight: '500',
                  color: loading ? '#000000' : 'white',
                  boxShadow: loading ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}
              >
                {t("assignment.add")}
              </Button>
            </Link>
            <Link to={`/editvehicleassignment/${selectedRowKeys[0]}`}>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={modificar}
                disabled={editarCargaButtonDisabled || selectedRowKeys.length !== 1}
                size="small"
                style={{
                  background: (editarCargaButtonDisabled || selectedRowKeys.length !== 1)
                    ? '#d9d9d9'
                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                  borderColor: (editarCargaButtonDisabled || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                  borderRadius: '8px',
                  height: '32px',
                  fontWeight: '500',
                  color: (editarCargaButtonDisabled || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                  boxShadow: (editarCargaButtonDisabled || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}
              >
                {t("assignment.edit")}
              </Button>
            </Link>
            <Button
              type="primary"
              icon={<LockOutlined />}
              onClick={(e) => { activacion(e, true); }}
              disabled={completarCargaButtonDisabled || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (completarCargaButtonDisabled || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: (completarCargaButtonDisabled || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (completarCargaButtonDisabled || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (completarCargaButtonDisabled || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              {t("assignment.completar_carga")}
            </Button>
            <Button
              type="primary"
              icon={<UnlockOutlined />}
              onClick={(e) => { activacion(e, false); }}
              disabled={habilitarCargaButtonDisabled || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (habilitarCargaButtonDisabled || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: (habilitarCargaButtonDisabled || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (habilitarCargaButtonDisabled || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (habilitarCargaButtonDisabled || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              {t("assignment.habilitar_carga")}
            </Button>
            <Button
              type="primary"
              icon={<ShareAltOutlined />}
              onClick={generarRuta}
              disabled={loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (loading || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (loading || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (loading || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              {t("assignment.route")}
            </Button>
            <Button
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={(e) => { confirmar(e, true); }}
              disabled={loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (loading || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                borderColor: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#52c41a',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (loading || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (loading || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(82, 196, 26, 0.3)'
              }}
            >
              {t("assignment.confirmar")}
            </Button>
            <Button
              danger
              icon={<CheckCircleOutlined />}
              onClick={(e) => { confirmar(e, false); }}
              disabled={loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                background: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#ff4d4f',
                borderColor: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#ff4d4f',
                color: (loading || selectedRowKeys.length !== 1) ? '#000000' : 'white'
              }}
            >
              {t("assignment.desconfirmar")}
            </Button>
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={eliminar}
              disabled={!hasSelected || loading}
              size="small"
              style={{
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                background: (!hasSelected || loading) ? '#d9d9d9' : '#ff4d4f',
                borderColor: (!hasSelected || loading) ? '#d9d9d9' : '#ff4d4f',
                color: (!hasSelected || loading) ? '#000000' : 'white'
              }}
            >
              {t("assignment.delete")}
            </Button>
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={recargar}
              loading={loading}
              size="small"
              style={{
                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              {t("global.reload")}
            </Button>
          </div>
        </Card>

        {/* Table */}
        <Card style={{
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: 'none'
        }}>
          {/* Filtro de búsqueda */}
          <div style={{
            marginBottom: '12px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Input
              placeholder="Buscar por matrícula..."
              prefix={<SearchOutlined />}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                filterLocal(e.target.value);
              }}
              style={{
                width: '250px',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
              size="small"
            />
            {searchValue && (
              <Button
                type="text"
                icon={<CloseCircleOutlined />}
                onClick={() => {
                  setSearchValue("");
                  filterLocal("");
                }}
                style={{
                  color: '#666',
                  borderRadius: '6px'
                }}
                size="small"
              >
                Limpiar
              </Button>
            )}
          </div>

          <Table
            size="small"
            scroll={{ x: 1500, y: 500 }}
            bordered={false}
            pagination={{
              position: [bottom],
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total) => `Total ${total} elementos`,
            }}
            columns={[
              {
                title: (
                  <p
                    style={{
                      margin: "0px 0",
                      fontSize: "15px",
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontFamily: "'Roboto', sans-serif",
                      textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
                    }}
                  >
                    {t("vehicle.matricula")}
                  </p>
                ),
                dataIndex: "matricula",
                key: "matricula",
                width: 220,
                render: (text) => (
                  <span style={{ fontWeight: '500', color: '#253289' }}>{text}</span>
                )
              },
              ...columns.slice(1)
            ]}
            rowSelection={rowSelection}
            onChange={handleTableChange}
            dataSource={data}
            onRow={(record) => {
              return {
                onDoubleClick: async () => {
                  // selectRowUpdate(record);
                },
              };
            }}
          />
        </Card>
      </Spin>
    </div>
  );
};
export default DeliveryAssignment;
